import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Textarea } from '@wayste/sour-ui';
import { Controller } from 'react-hook-form';
import { CollapsibleCardSectionHeader } from '../../components/roll-off-ordering/CollapsibleCard';
export function WasteContentSection({ control, name }) {
    return (_jsxs(_Fragment, { children: [_jsx(CollapsibleCardSectionHeader, { text: 'Waste Information*' }), _jsx(Controller, { rules: { required: 'required' }, control: control, name: name, render: ({ field, fieldState }) => {
                    return (_jsx(Textarea, { placeholder: 'What will you be putting in the dumpster?', inputProps: { ...field }, error: fieldState.error }));
                } })] }));
}
//# sourceMappingURL=WasteContentSection.js.map